import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/auth.guard';

import { InsureComponent } from './insure.component';
import { InsureManageComponent } from './components/insure-manage/insure-manage.component';
import { InsureBuyComponent } from './components/insure-buy/insure-buy.component';
import { InsureQuoteComponent } from './components/insure-quote/insure-quote.component';
import { InsureHomeComponent } from './components/insure-home/insure-home.component';

const routes: Routes = [
  {
    path: '', component: InsureComponent,
    children: [
      { path: '', component: InsureHomeComponent },
      { path: 'quote', component: InsureQuoteComponent  },
      { path: 'buy', canActivate: [AuthGuard], component: InsureBuyComponent  },
      { path: 'manage', canActivate: [AuthGuard], component: InsureManageComponent  },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class InsureRoutingModule { }
